<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom p-0">
    <div class="container">
      <a class="navbar-brand mr-0 mr-sm-3 d-flex" :href="urlHome"
        >
        <span class="logo align-self-center">
          <img
            :src="logoURL"
            class="img-fluid"
            :title="'Prefeitura de Belo Horizonte'"
            alt="Logo Prefeitura de Belo Horizonte"
          >
        </span> 
        <span class="divisoria mx-2">
          |
        </span>
          <div class="titulo">
            <span>
            {{ nomeSistema }}<small>{{ siglaSistema }}</small>    
          </span>
        </div>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="navbar-collapse w-100 order-3 collapse2 collapse show"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <slot name="before-items"></slot>

          <li v-for="item in itensMenu" :key="item.label" class="nav-item">
            <piweb-menu-item
              v-if="menuHasSubmenu(item)"
              :menu="item"
            ></piweb-menu-item>
            <component
              :is="linkType"
              v-else
              class="nav-link mt-2 mt-lg-0 py-1 py-lg-3"
              aria-current="page"
              :href="item.link ? item.link : '/#'"
              :to="item.link ? item.link : '/#'"
              >{{ item.label }}</component
            >
          </li>
          <slot name="after-items"></slot>

          <piweb-menu-usuario
            :usuario="usuario"
            :fnLogout="fnLogout"
            v-if="Object.keys(usuario).length"
          >
            <template v-slot:after-nome-usuario>
              <slot name="menu-usuario-after-nome-usuario"> </slot>
            </template>
            <template v-slot:before-logout>
              <slot name="menu-usuario-before-logout"> </slot>
            </template>
          </piweb-menu-usuario>

          <slot name="after-menu-usuario"></slot>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import PiwebMenuUsuario from "./piweb-menu-usuario.vue";
import PiwebMenuItem from "./piweb-menu-item.vue";

export default {
  name: "Topo",
  components: { PiwebMenuUsuario, PiwebMenuItem },
  props: {
    logoURL: {
      type: String,
      default: ""
    },
    siglaSistema: { type: String, default: "SIGLA" },
    nomeSistema: { type: String, default: "Nome completo" },
    urlHome: { type: String, default: "/" },
    itensMenu: {
      type: Array,
      default: () => [],
    },
    usuario: {
      type: Object,
      default: () => {
        return { nomeCompleto: "Nome Sobrenome" };
      },
    },
    fnLogout: {
      type: Function,
      default: () => {
        alert("Logout!");
      },
    },
  },
  computed: {
    linkType() {
      return this.$router ? "router-link" : "a";
    },
  },
  methods: {
    menuHasSubmenu(menu) {
      return Object.keys(menu).includes("subitens");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-brand {
  font-family: DINPro-Medium, Arial, sans-serif;
}

nav.navbar {
  font-family: DINPro-Regular, Arial, sans-serif;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
  color: #666;
  min-height: 57px;
  padding: 0;
}

.navbar-nav .dropdown-menu {
  width: 20em;
}

.router-link-exact-active,
.router-link-active,
.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-nav .nav-link:focus,
.navbar-nav .nav-link:hover {
  background-color: #e7e7e7;
}
</style>
